module.exports = __webpack_public_path__ + "media/images/gallery/constellations/corvus/crv_names-3f37c3a0ca9e2b6ec36444936a54786c.gif";